import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-3xl p-8 border-2 border-slate-100 text-center">
          <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
          <h2 className="text-2xl font-heading font-bold mb-2">Payment Cancelled</h2>
          <p className="text-slate-600 mb-6">No charges were made to your account</p>
          <Button
            onClick={() => navigate('/settings')}
            className="bg-violet-600 hover:bg-violet-700 text-white rounded-full font-heading"
          >
            Back to Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;